import { ResponsivePieCanvas } from "@nivo/pie";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useEffect, useState } from "react";
import { colorCodes } from "./colorCodes";

const CountryStats = ({ data }) => {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();

  const [userPhoneNumbers, setUserPhoneNumbers] = useState([]);

  useEffect(() => {
    const phoneNumbers = data.map((user) => user.phoneNumber);
    setUserPhoneNumbers(phoneNumbers);
  }, [data]);

  const countryCounts = [];

  userPhoneNumbers.forEach((phoneNumber) => {
    try {
      const phoneNumberObj = phoneNumberUtil.parse(phoneNumber);
      const countryCode = phoneNumberObj.getCountryCode();

      if (countryCounts[countryCode]) {
        countryCounts[countryCode]++;
      } else {
        countryCounts[countryCode] = 1;
      }
    } catch (error) {
      console.error(`Error parsing phone number ${phoneNumber}:`, error);
    }
  });

  const userCountsByCountry = Object.entries(countryCounts).map(
    ([countryCode, count], i) => {
      try {
        const countryName = phoneNumberUtil.getRegionCodeForCountryCode(
          parseInt(countryCode)
        );
        return {
          id: countryName,
          label: countryName,
          value: count,
          color: colorCodes[i],
        };
      } catch (error) {
        console.error(
          `Error getting country name for country code ${countryCode}:`,
          error
        );
        return {
          id: "Unknown",
          label: "Unknown",
          value: count,
          color: colorCodes[i],
        };
      }
    }
  );

  return (
    <ResponsivePieCanvas
      data={userCountsByCountry}
      margin={{ top: 40, right: 100, bottom: 40, left: 100 }}
      startAngle={-84}
      innerRadius={0.7}
      padAngle={1}
      cornerRadius={8}
      activeOuterRadiusOffset={8}
      colors={{ scheme: "dark2" }}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.6]],
      }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor="#333333"
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      legends={[
        {
          anchor: "right",
          direction: "row",
          justify: false,
          translateX: -60,
          translateY: 200,
          itemsSpacing: 4,
          itemWidth: 70,
          itemHeight: 14,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 14,
          symbolShape: "circle",
        },
      ]}
    />
  );
};

export default CountryStats;
